var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-combo-box',{ref:"combobox",staticClass:"work-mode-switch",attrs:{"options":_vm.workModeOptions,"dropdown-menu-alignment":1,"dropdown-menu-offset-top":-24,"dropdown-menu-header":"Work Mode","initial-value":_vm.workMode,"theme":"light"},on:{"userSelectOption":_vm.onWorkModeSelectChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }